import { useState } from 'react';
import Modal from './Modal';
import { extrairMensagemErro } from './ErroCarregamento';

/** Confirmação para ação destrutiva (excluir endpoint/evento, rotacionar credencial).
 *  Nada aqui some sozinho: o erro do backend aparece dentro do próprio modal. */
export default function ConfirmarModal({
  titulo,
  mensagem,
  textoBotao = 'Confirmar',
  tom = 'danger',
  onConfirmar,
  onClose,
}) {
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const confirmar = async () => {
    setSalvando(true);
    setErro('');
    try {
      await onConfirmar();
      onClose();
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível concluir a ação.'));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal titulo={titulo} onClose={onClose} largura={460}>
      <p style={{ color: 'var(--wh-ink-2)' }}>{mensagem}</p>
      {erro && (
        <div className="alert alert-danger py-2 px-3" style={{ fontSize: 13 }}>
          {erro}
        </div>
      )}
      <div className="d-flex justify-content-end gap-2 mt-3">
        <button type="button" className="wh-btn wh-btn-outline" onClick={onClose} disabled={salvando}>
          Cancelar
        </button>
        <button
          type="button"
          className={`wh-btn ${tom === 'primary' ? 'wh-btn-primary' : 'wh-btn-danger'}`}
          onClick={confirmar}
          disabled={salvando}
        >
          {salvando ? 'Processando...' : textoBotao}
        </button>
      </div>
    </Modal>
  );
}
